import { render, staticRenderFns } from "./NewsPagination.vue?vue&type=template&id=702fef9a&"
import script from "./NewsPagination.vue?vue&type=script&lang=js&"
export * from "./NewsPagination.vue?vue&type=script&lang=js&"
import style0 from "./NewsPagination.vue?vue&type=style&index=0&id=702fef9a&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports